// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__qIIAF"};
module.exports.__checksum = "44f43110d107"